import type { GenericNode } from '../../types'
import { FlowNodeTypes } from '../../types'

/**
 * The one rule for "which canvas nodes are @-mentionable and what to call
 * them" — consumed by the mention popover and the mention renderer so node
 * naming / exclusions change in exactly one place.
 */
export interface MentionableNode {
  id: string
  name: string
  type: string
}

export const getMentionableNodes = (nodes: GenericNode[]): MentionableNode[] =>
  nodes
    .filter((node) => {
      const nodeType = node.type as FlowNodeTypes
      return nodeType !== FlowNodeTypes.select_trigger && nodeType !== FlowNodeTypes.note
    })
    .map((node) => ({
      id: node.id,
      name: (node.data?.config?.name || node.data?.meta?.name || node.id) as string,
      type: (node.type as string) ?? '',
    }))
